import React from 'react';
import type { Route } from 'contracts';

import welcomeId from '../steps/welcome/@@global/id';
import profilePhotoId from '../steps/profile-photo/@@global/id';
import displayNameId from '../steps/display-name/@@global/id';
import downloadAppsId from '../steps/download-apps/@@global/id';

import id from './id';

// Import step routes
const AsyncWelcome = React.lazy(() => import('../steps/welcome'));
const AsyncProfilePhoto = React.lazy(() => import('../steps/profile-photo'));
const AsyncDisplayName = React.lazy(() => import('../steps/display-name'));
const AsyncDownloadApps = React.lazy(() => import('../steps/download-apps'));

const AsyncLayout = React.lazy(() => import('../layout'));

const routes: Route = {
  name: id,
  path: '/{lang?}/preonboarding',
  element: <AsyncLayout />,
  meta: {
    hideSidebar: true,
  },
  children: [
    {
      name: welcomeId,
      path: '/welcome',
      element: <AsyncWelcome />,
      meta: {
        hideSidebar: true,
      },
    },
    {
      name: downloadAppsId,
      path: '/download-apps',
      element: <AsyncDownloadApps />,
      meta: {
        hideSidebar: true,
      },
    },
    {
      name: profilePhotoId,
      path: '/profile-photo',
      element: <AsyncProfilePhoto />,
      meta: {
        hideSidebar: true,
      },
    },
    {
      name: displayNameId,
      path: '/display-name',
      element: <AsyncDisplayName />,
      meta: {
        hideSidebar: true,
      },
    },
  ],
};

export default routes;
